var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tabs",
    { staticClass: "configurations", attrs: { "content-class": "pt-1" } },
    [
      _c(
        "b-tab",
        { attrs: { title: "System" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [
              _c(
                "b-col",
                { attrs: { md: "12", lg: "6" } },
                [
                  _c("confidence-colors"),
                  _vm._v(" "),
                  _c("temp-config-bulk-update"),
                  _vm._v(" "),
                  _c("brands")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "12", lg: "6" } },
                [
                  _c("doc-retention", {
                    attrs: {
                      retentionTime: this.retentionTime,
                      retentionDaysCount: this.retentionDaysCount
                    }
                  }),
                  _vm._v(" "),
                  _c("doc-escalation-time", {
                    attrs: {
                      "escalation-time": this.escalationTime,
                      escalationDaysCount: this.escalationDaysCount
                    }
                  }),
                  _vm._v(" "),
                  _c("process-type"),
                  _vm._v(" "),
                  _c("process-order"),
                  _vm._v(" "),
                  _c("role-order"),
                  _vm._v(" "),
                  _c("auto-processing", {
                    attrs: { is_auto_processing: this.is_auto_processing }
                  }),
                  _vm._v(" "),
                  _c("local-time", { attrs: { local_time: this.local_time } }),
                  _vm._v(" "),
                  _c("authConfig")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Service Mappings" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [_c("external-service-maps")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Service Validations" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [_c("external-service-validations")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Custom Validations" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [_c("custom-validations")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Manage Fields" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [_c("b-col", { attrs: { md: "12" } }, [_c("manageFields")], 1)],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Auto Correct" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [_c("b-col", { attrs: { md: "12" } }, [_c("autoCorrect")], 1)],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "API-Response Json Formatter" } },
        [
          _c(
            "b-row",
            { attrs: { "justify-content-md": "" } },
            [
              _c(
                "b-col",
                { attrs: { md: "12" } },
                [_c("api-response-json-formatter")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85218802", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85218802","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/settings/configurations.vue
// module id = 1415
// module chunks = 2